import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import FormSF from '../../../widgets/form/FormSF'
import InputTextSF from '../../../widgets/form/InputTextSF'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SuperUserPageSF from '../../../templates/SuperUserPageSF'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const PasswordChangePageUI = ({ context, successMsg, errorList,
      submitted, onSubmit, onCancel, setErrorList,
      oldPassword, oldPasswordError, onOldPasswordChange, setOldPasswordError,
      newPassword, newPasswordError, onNewPasswordChange, setNewPasswordError,
      reenterPassword, reenterPasswordError, onReenterPasswordChange, setReenterPasswordError
 }) =>
  <SuperUserPageSF context={context} className='pg_su_passwd' backLink='/su/settings'
    headerText='Change password'>
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    <div>
      <PageTitleUI context={context} goBack={true} backLink='/su/settings' titleText='Change password' />
      <CardUI context={context}>
        <FormSF context={context} buttonLabel='Change'
          successMsg={successMsg} errorList={errorList}
          busy={submitted} onSubmit={onSubmit} onCancel={onCancel} setErrorList={setErrorList}
        >
          <InputTextSF type='password' name='oldPassword' required={true} maxLength={40}
            label='Old password'
            value={oldPassword} error={oldPasswordError} onChange={onOldPasswordChange} setError={setOldPasswordError}
            autoFocus={true}
          />
          <InputTextSF type='password' name='newPassword' required={true} maxLength={40}
            label='New password'
            value={newPassword} error={newPasswordError} onChange={onNewPasswordChange} setError={setNewPasswordError}
          />
          <InputTextSF type='password' name='reenterPassword' required={true} maxLength={40}
            label='Re-enter password'
            value={reenterPassword} error={reenterPasswordError} onChange={onReenterPasswordChange} setError={setReenterPasswordError}
          />
        </FormSF>
      </CardUI>
    </div>
  </SuperUserPageSF>

export default PasswordChangePageUI
